import { useState, useEffect } from "react";
import { COMMOM_MAX_WIDTH } from "../constants/commonConstants";

interface IIsMobileProps {
	maxWidth?: number;
}

export default function IsMobile({ maxWidth = COMMOM_MAX_WIDTH }: IIsMobileProps = {}) {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= maxWidth);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= maxWidth);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return isMobile;
}
